import styled from "styled-components";

export const NotPaddedPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  position: relative;
  background: #FFFFFF;
  border-radius: 30px;
  overflow: auto;

  @media only screen and (min-width:768px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;
    border-radius: 20px;
    border: 10px solid ${window?.settings?.sidebar_color ?? '#04333b'};
    margin: 0px;
    padding-bottom: 0px;
  }
`; 